import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Session } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("[ProtectedRoute] Checking session");
    supabase.auth.getSession().then(({ data: { session } }) => {
      console.log("[ProtectedRoute] Session status:", session ? "Found" : "Not found");
      setSession(session);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      console.log("[ProtectedRoute] Auth state changed:", _event);
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    console.log("[ProtectedRoute] Still loading...");
    return <div>Loading...</div>;
  }

  if (!session) {
    console.log("[ProtectedRoute] No session, redirecting to auth");
    return <Navigate to="/auth" replace />;
  }

  console.log("[ProtectedRoute] Session valid, rendering protected content");
  return <>{children}</>;
};